<template>
    <Box :width="'285px'" :color="'#8a66c7'" :background="'#F5E9FF'">
        <template #title> 
            Data 
            <button @click="downloadEvt" :class="{inactive: !allowDownload}"> Download </button>
        </template>
        <template #content>
            <div style="display: flex; flex-direction: column; gap: 10px; width: 100%; align-items: center; padding: 10px; height: 430px; justify-content: space-between;">
                <LabelSelector v-if="!showCamera && trainer" :labels="trainer.classes" :focusClass="focusClass" @update:focusClass="focusClass = $event" />
                <Camera purple v-if="showCamera" @update="cameraEvt" :resolution="320"/>
                
                <div class="imageContainer" :class="{vertical: !showCamera}">
                    <div v-if="!showCamera" style="display: flex; width: 100%; color: #8A66C7; gap: 5px; padding: 5px 10px;">
                        <label style="font-weight: 600;">Image Count: </label>
                        <label style="font-weight: 600; width: max-content;">{{ selectedData.length }}</label>
                    </div>
                    <ImageData v-for="data in selectedData" :key="data" ref="imageComponent"
                        :data="data" :isFocus="focusData == data" @click="focusDataEvt(data)" @remove="removeDataEvt(data)">
                        <div v-for="region in data.regions" :key="region" class="region"
                            :style="{ background: trainer.getClass(region.classId)?.color,
                                width: `${region.width * 100 / 320}%`, height: `${region.height * 100 / 320}%`,
                                top: `${region.top * 100 / 320}%`, left: `${region.left * 100 / 320}%`}">
                        </div>
                    </ImageData>
                </div>
                <div style="display: flex; gap: 10px; width: 100%;">
                    <button @click.stop="showCamera = false" style="height: 40px; width: 80px;" v-if="showCamera">Back</button>
                    <button @click.stop="captureEvt" style="height: 40px; width: 100%;" v-if="showCamera">Capture</button>
                    <button @click.stop="showCamera = true" style="width: 100%; height: 36px;" v-if="!showCamera"> Collect Data </button>
                </div>
            </div>
        </template>
    </Box>
</template>

<script>
import {Box, Camera} from '@/index.js'
import {ObjectDetectionTrainer, ObjectDetectionData} from '../../scripts/ObjectDetection.js';
import ImageCanvas from '@/tm/ImageCanvas.vue';
import {utils} from '@/index.js'
import LabelSelector from './LabelSelector.vue';
import ImageData from './ImageData.vue';

export default {
    props: {
        trainer: {
            type: ObjectDetectionTrainer,
            default: new ObjectDetectionTrainer()
        },
        focusData: {
            type: ObjectDetectionData,
            default: new ObjectDetectionData()
        }
    },
    components:{
        Box,
        Camera,
        ImageCanvas,
        LabelSelector,
        ImageData
    },
    data(){
        return{
            showCamera: true,
            focusClass: null,
        }
    },
    computed:{
        data(){
            return this.trainer.getData()
        },
        selectedData(){
            if (this.focusClass == -1) {
                return this.data.filter(data => data.regions.length <= 0)
            } else if (this.focusClass){
                return this.data.filter(data => data.regions.some(region => region.classId === this.focusClass.id))
            } else {
                return this.data
            }
        },
        allowDownload(){
            return this.data && this.data.length > 0
        }
    },
    methods: {
        cameraEvt(canvas){
            this.canvas = canvas
        },
        captureEvt(){
            if (!this.canvas) {
                return
            }
            const imageData = this.canvas.getContext('2d').getImageData(0, 0, 320, 320)
            const data = this.trainer.addData(imageData)
            this.$emit('update:focusData', data)
        },
        async downloadEvt(){
            const blob = await this.trainer.toBlob()
            utils.downloadFile('data.zip', blob)
        },
        focusDataEvt(data){
            this.$emit('update:focusData', data)
        },
        removeDataEvt(data){
            this.trainer.removeData(data)
        },
        scorllToFocusData(behavior = "smooth"){
            this.$nextTick(() => {
                if (!this.$refs.imageComponent) {
                    return
                }
                const target = this.$refs.imageComponent.find(component => component.isFocus);
                if (target) {
                    target.$el.scrollIntoView({ behavior: behavior, block: "center", inline: "center" });
                }
            })
        },
    },
    watch: {
        focusData() {
            this.scorllToFocusData();
        },
        showCamera(){
            this.scorllToFocusData("instant");
        }
    }
}
</script>

<style scoped>
button{
    background: #f5e8fe;
    border: 2px solid #8a66c7;
    color: #8a66c7;
    border-radius: 5px;
    min-height: 26px;
    cursor: pointer;
}

button:hover{
    background: #e9d5fb;

}

button.inactive{
    pointer-events: none;
    filter: grayscale(1);
}
</style>

<style scoped>
.imageContainer{
    min-height: 90px; width: 100%; display: flex; 
    gap: 5px; 
    overflow-x: scroll; 
    overflow-y: hidden;
    padding: 5px;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.25) 0px 0px 0px 1px;
}

.imageContainer.vertical{
    flex: 1;
    overflow-x: hidden; 
    overflow-y: scroll;
    flex-wrap: wrap;
    align-content: flex-start;
}

.imageContainer::-webkit-scrollbar {
    -webkit-appearance: none;
}

.imageContainer::-webkit-scrollbar:vertical {
    width: 10px;
    height: 100%;
}

.imageContainer::-webkit-scrollbar:horizontal {
    height: 10px;
    width: 100%;
}

.imageContainer::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, .3);
}

.imageContainer::-webkit-scrollbar-thumb:hover {
    border-radius: 8px;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, .5);
}

.imageContainer::-webkit-scrollbar-track { 
    border-radius: 10px; 
} 

.region{
    border: 1px dotted #fff; border-radius: 0; 
    background: rgba(255, 255, 255, 0.5); 
    position: absolute; opacity: 0.7;
}
</style>